<template>
    <v-container class="p-product-container">
        <Navigation
            :category1.sync="category1"
            :category2.sync="category2"
            :onlineStatus.sync="onlineStatus"
            @getList="getList"
        />
        <v-container class="p-product-list">
            <div>
                <ListItem v-for="item in productsList" :key="item.id" :product="item"></ListItem>
            </div>
        </v-container>
    </v-container>
</template>

<script>
    import ListItem from "./components/ListItem";
    import Navigation from "./components/Navigation";
    export default {
        components: {
            Navigation,
            ListItem
        },
        data() {
            return {
                tabActive: 0,
                category1: "",
                category2: "",
                onlineStatus: 0,
                form: {},
                productsList : []
            };
        },
        created() {
            this.category1 = this.$route.params.type;
        },
        computed: {

        },
        methods:{
            getList(form){
                this.$axios.get("/json/person_productlist.json", form).then(data => {
                    let list = form.onlineStatus && data[form.code] ? data[form.code].find(item => item.onlineStatus == form.onlineStatus) : data[form.code]
                    this.productsList = list || [];
                    this.productsList = this.productsList.length > 0 && this.productsList.map(item => {
                        if (item.productDetailBo.hasOwnProperty("features") && item.productDetailBo.features !== ""){
                            item.productDetailBo.features = JSON.parse(item.productDetailBo.features);
                        }
                        if (item.productDetailBo.hasOwnProperty("conditions") && item.productDetailBo.conditions !== ""){
                            item.productDetailBo.conditions = JSON.parse(item.productDetailBo.conditions);
                        }
                        return item;
                    })
                });
            }
        }
    }
</script>

<style lang="scss">
    .p-product-container {

    }
    .p-product-list {
        // tabs 少于两个的时候隐藏
        .hide-tabs_bar {
            .v-tabs__bar {
                display: none;
            }
        }
        .category-tabs {
            .v-tabs__bar {
                // padding: 8px 20px;
                padding-left: 20px;
                .v-tabs__item {
                    font-size: 14px;
                    // color: $font-color;
                    // opacity: 1;
                }
                // tabs 文字下的滑动线
                .v-tabs__slider {
                    width: 32px;
                    margin: auto;
                }
            }
        }
    }
</style>
